module.exports = __webpack_public_path__ + "static/media/burning-pop.e771df57.svg";